export default [
    "24 24",
    '<path d="M5 12L10.0004 17L20 7" fill="none" stroke="var(--ci-primary-color, currentColor)" class="stroke-over" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

